export default __webpack_public_path__ + "static/media/battery.83d39c50.svg";